<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style>
  @import './assets/flex-css/flex.css';

  div {
    box-sizing: border-box;
  }

  p {
    margin: 0;
  }

  .margin-t-10 {
    margin-top: 10px;
  }

  .margin-t-20 {
    margin-top: 20px;
  }

  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
  }
</style>